// @file Types only used on the Dashboard
import type { AccountKey, SharedCollectionAccountKey, WallViz } from '@@/types'
import type { CollectionKey, WallsFilter } from '@@/types/collections'

export enum MobilePage {
  AccountsMenu = 'AccountsMenu',
  CollectionsMenu = 'CollectionsMenu',
  Collection = 'Collection',
  GettingStarted = 'GettingStarted',
  Join = 'Join',
  More = 'More',
  Search = 'Search',
  LayoutPicker = 'LayoutPicker',
  Learn = 'Learn',
}

export enum Audience {
  FeaturedGallery = 'featured_gallery',
  General = 'general',
  Education = 'education',
  Business = 'business',
}

// Note, if we add more class tabs, please update the number of cells displayed
// in the DashDesktopHomeMenuRowsSkeleton component in CampusDashDesktopClassMenuTabRows.vue
export enum ClassTabs {
  Announcements = 'announcements',
  Padlets = 'padlets',
  Assignments = 'assignments',
}

export interface DashView {
  audience?: Audience
  accountKey?: AccountKey
  collectionKey?: CollectionKey
  mobilePage?: MobilePage
  page?: string
  filter?: WallsFilter
  gallery?: WallViz | 'all'
  make?: 'make'
  learn?: 'learn'
  sharedCollectionAccountKey?: SharedCollectionAccountKey
  librarySlug?: string
  classSlugWithHashId?: string // this value is formatted as "classSlug-classHashId"
  tab?: ClassTabs
}

export interface NonCurrentTenantAccountsMenuItem {
  name: string
  username: string
  email?: string
  logo: string
  tenantName?: string
  tenantDomainName?: string
  isNative: boolean
  url: string
}
